import { render } from "./SoundControl.vue?vue&type=template&id=04232fe0"
import script from "./SoundControl.vue?vue&type=script&lang=js"
export * from "./SoundControl.vue?vue&type=script&lang=js"

import "./SoundControl.vue?vue&type=style&index=0&id=04232fe0&lang=scss"
script.render = render

export default script